// import React, { useEffect, useState } from "react";
// import { Tooltip, Modal, Box, Typography, CircularProgress } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import moment from "moment/moment";
// import staffService from "../../../Services/staffService";


// const Staff = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const getStaff = async () => {
//       try {
//         setLoading(true);
//         const response = await staffService.fetchAll();
//         console.log(response);
//         setPatients(response.staffs);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching doctors');
//       }
//     };
//     getStaff();
//   }, []);

//   useEffect(() => {
//     const filteredResult = patients?.filter(
//       (item) =>
//         item?.full_name?.toLowerCase().includes(searchData.toLowerCase())
//     ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleViewClick = (doctor) => {
//     setSelectedDoctor(doctor);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedDoctor(null);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Doctors</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">{filteredData?.length || 0} records found</h1>
        
//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <Link to='AddEditStaff'>
//             <button className="bg-[#232233] h-[2rem] px-4 rounded-md text-white font-[600] text-[14px]">
//               + New Staff
//             </button>
//           </Link>
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%]">
//             <thead>
//               <tr className="text-[#101418] capitalize leading-normal text-sm">
//               <th className="py-[1%] w-[10%]  text-gray-700 text-left pl-4">Sr No.</th>
//               <th className="py-[1%] w-[20%]  text-gray-700 text-left pl-4">Full Name</th>
//                 <th className="py-[1%] w-[10%]  text-gray-700 text-left pl-4">Designation</th>
//                 <th className="py-[1%] w-[10%]  text-gray-700 text-left">Qualification</th>
//                 <th className="py-[1%] w-[20%]  text-gray-700 text-center">Address</th>
//                 <th className="py-[1%] w-[20%]  text-gray-700 text-center">Date of Appointment</th>
//                 <th className="py-[1%] w-[10%]  text-gray-700 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr key={patient?.patient_id} className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200">
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600 text-center">{patient?.staff_id}</p>
//                   </td>
//                   <td className="w-[20%] text-left">
//                     <p className="font-[600] text-gray-600 text-left">{patient?.full_name}</p>
//                   </td>
//                   <td className="py-[1%] w-[10%] text-left pl-4">
//                     <p className="font-[600] text-gray-600">{patient?.role_name}</p>
//                   </td>
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600">{patient?.qualification}</p>
//                   </td>
//                   <td className="py-[2%] px-2 w-[20%] text-center">
//                     <span className="font-[400]">{patient?.address}</span>
//                   </td>
//                   <td className="py-[2%] px-2 w-[20%] text-center">
//                     <span className="font-[400]">{moment(patient?.hire_date).format("ll")}</span>
//                   </td>
                
//                    <td className="py-[2%] w-[10%] text-center">
//                     <button
//                       onClick={() => handleViewClick(patient)}
//                       className="text-[13px] font-[500] text-blue-500"
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           data={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>

//       {/* <DoctorDetailsModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         doctorDetails={selectedDoctor}
//       /> */}
//     </div>
//   );
// };

// export default Staff;




import React, { useEffect, useState } from "react";
import { Modal, Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import moment from "moment/moment";
import staffService from "../../../Services/staffService";

const Staff = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const getStaff = async () => {
      try {
        setLoading(true);
        const response = await staffService.fetchAll();
        setPatients(response.staffs);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching staff");
      }
    };
    getStaff();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.full_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const handleViewClick = (doctor) => {
    setSelectedDoctor(doctor);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDoctor(null);
  };

  return (
    <div className="p-3 sm:p-6">

      {/* ── HEADER ── */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[16px] sm:text-[17px] font-[500] text-gray-800">Staff Table</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
          {/* Search */}
          <div className="relative w-full xs:w-auto">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by name..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-full xs:w-[200px] sm:w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          <Link to="AddEditStaff" className="w-full xs:w-auto">
            <button className="w-full bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[7px] rounded-lg whitespace-nowrap">
              + New Staff
            </button>
          </Link>
        </div>
      </div>

      {/* ── TABLE — desktop (md+) ── */}
      <div className="hidden md:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="bg-[#215187] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Sr No.</th>
                <th className="py-3 px-4 text-left">Full Name</th>
                <th className="py-3 px-4 text-left">Designation</th>
                <th className="py-3 px-4 text-left">Qualification</th>
                <th className="py-3 px-4 text-center">Address</th>
                <th className="py-3 px-4 text-center">Date of Appointment</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400 text-[13px]">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData?.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400 text-[13px]">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData?.map((patient) => (
                  <tr key={patient?.staff_id} className="border-t hover:bg-gray-50 text-[13px]">
                    <td className="py-3 px-4">{patient?.staff_id}</td>
                    <td className="py-3 px-4 font-[500]">{patient?.full_name}</td>
                    <td className="py-3 px-4">{patient?.role_name}</td>
                    <td className="py-3 px-4">{patient?.qualification}</td>
                    <td className="py-3 px-4 text-center">{patient?.address}</td>
                    <td className="py-3 px-4 text-center">
                      {moment(patient?.hire_date).format("ll")}
                    </td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => handleViewClick(patient)}
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── CARDS — mobile/tablet (below md) ── */}
      <div className="md:hidden flex flex-col gap-3">
        {loading ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            Loading...
          </div>
        ) : paginatedData?.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            No records found
          </div>
        ) : (
          paginatedData?.map((patient) => (
            <div
              key={patient?.staff_id}
              className="bg-white border border-gray-200 rounded-xl px-4 py-4 shadow-sm"
            >
              {/* Card top: name + view button */}
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="text-[14px] font-semibold text-gray-800 leading-tight">
                    {patient?.full_name}
                  </p>
                  <p className="text-[11px] text-gray-400 mt-0.5">ID: {patient?.staff_id}</p>
                </div>
                <button
                  onClick={() => handleViewClick(patient)}
                  className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100 flex-shrink-0 ml-2"
                >
                  View
                </button>
              </div>

              {/* Card details grid */}
              <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                <div>
                  <p className="text-[10px] text-gray-400 uppercase tracking-wide">Designation</p>
                  <p className="text-[12px] text-gray-700 font-medium">{patient?.role_name || "—"}</p>
                </div>
                <div>
                  <p className="text-[10px] text-gray-400 uppercase tracking-wide">Qualification</p>
                  <p className="text-[12px] text-gray-700 font-medium">{patient?.qualification || "—"}</p>
                </div>
                <div>
                  <p className="text-[10px] text-gray-400 uppercase tracking-wide">Address</p>
                  <p className="text-[12px] text-gray-700 font-medium">{patient?.address || "—"}</p>
                </div>
                <div>
                  <p className="text-[10px] text-gray-400 uppercase tracking-wide">Appointed</p>
                  <p className="text-[12px] text-gray-700 font-medium">
                    {moment(patient?.hire_date).format("ll")}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
      />

      {/* ── VIEW DETAIL MODAL ── */}
      <Modal open={isModalOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100% - 32px)", sm: 480 },
            maxHeight: "90vh",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Modal Header */}
          <div className="bg-[#215187] px-5 sm:px-6 py-4 flex items-center justify-between flex-shrink-0">
            <Typography className="!text-white !text-[15px] sm:!text-[16px] !font-semibold">
              Staff Details
            </Typography>
            <button
              onClick={handleCloseModal}
              className="text-gray-300 hover:text-white text-[22px] leading-none"
            >
              &times;
            </button>
          </div>

          {/* Modal Body — scrollable */}
          {selectedDoctor && (
            <div className="px-5 sm:px-6 py-5 flex flex-col gap-3 overflow-y-auto">

              {[
                { label: "Staff ID",            value: selectedDoctor.staff_id },
                { label: "Full Name",           value: selectedDoctor.full_name },
                { label: "Designation",         value: selectedDoctor.role_name },
                { label: "Qualification",       value: selectedDoctor.qualification },
                { label: "Address",             value: selectedDoctor.address },
                { label: "Date of Appointment", value: moment(selectedDoctor.hire_date).format("ll") },
              ].map((row, i, arr) => (
                <div
                  key={row.label}
                  className={`flex justify-between items-start gap-4 ${i < arr.length - 1 ? "border-b pb-3" : ""}`}
                >
                  <span className="text-[12px] sm:text-[13px] text-gray-500 font-medium flex-shrink-0">
                    {row.label}
                  </span>
                  <span className="text-[12px] sm:text-[13px] text-gray-800 font-semibold text-right">
                    {row.value}
                  </span>
                </div>
              ))}

              <button
                onClick={handleCloseModal}
                className="mt-2 w-full bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          )}
        </Box>
      </Modal>

    </div>
  );
};

export default Staff;